import { useState, useEffect } from "react";
import { ArrowUpRight } from "lucide-react";
import { ModuleIcon } from "./ModuleIcon";
import { fetchCollectionValue } from "../lib/api";
import { eur } from "../lib/prices";
import { CardImage } from "./CardImage";

// Tuile d'accueil « En hausse récente » : comble le vide laissé par le
// rétrécissement de la tuile « Il te manque » (elle prenait toute la largeur
// alors que la carte affichée restait petite). Réutilise `data.risers`, déjà
// calculé par `fetchCollectionValue` pour la vue Valeur estimée — zéro appel
// réseau supplémentaire côté backend.
export const TopRisersCard = ({ onCardClick, onSeeAll }) => {
  const [risers, setRisers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCollectionValue()
      .then(data => setRisers((data.risers || []).slice(0, 8)))
      .catch(err => console.error("En hausse récente :", err))
      .finally(() => setLoading(false));
  }, []);

  if (!loading && risers.length === 0) return null;

  return (
    <div className="stat-widget h-full flex flex-col">
      <div className="absolute top-0 right-0 w-32 h-32 rounded-full blur-3xl opacity-[0.15] bg-emerald-500 pointer-events-none"></div>

      <div className="flex items-center gap-2 mb-4">
        <ModuleIcon icon={ArrowUpRight} color="bg-emerald-500" size="lg" />
        <span className="text-xs uppercase tracking-wider text-zinc-500 font-semibold">En hausse récente</span>
        {onSeeAll && (
          <button onClick={onSeeAll} className="ml-auto text-xs text-zinc-500 hover:text-white shrink-0">
            Tout voir
          </button>
        )}
      </div>

      {/* Grille de PETITES vignettes (pas une liste, pas des cartes géantes) :
          une seule colonne laissait la moitié de la tuile vide, mais une carte
          en pleine largeur par cellule était devenue énorme. Miniature fixe
          + texte à côté, 2 colonnes sur mobile, 3 dès que la place le permet. */}
      <div className="flex-1 grid grid-cols-2 gap-x-3 gap-y-3 content-center">
        {risers.map(card => (
          <button key={`${card.id}::${card.owned_variant}`} onClick={() => onCardClick(card)}
            className="flex items-center gap-3 text-left rounded-lg hover:bg-zinc-800/60 p-2 -mx-2">
            {card.image ? (
              <CardImage card={card} quality="low" className="w-14 h-[78px] object-cover rounded shrink-0 ring-1 ring-white/10" />
            ) : (
              <div className="w-14 h-[78px] rounded bg-zinc-800 shrink-0 ring-1 ring-white/10" />
            )}
            <div className="min-w-0 flex-1">
              <div className="text-sm font-semibold text-white leading-tight line-clamp-2">{card.name}</div>
              <div className="flex items-center gap-1.5 mt-0.5">
                <span className="text-sm font-bold text-emerald-400 shrink-0">+{card.delta_pct}%</span>
                <span className="text-xs text-zinc-500 truncate">{eur(card.variant_price)}</span>
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};
